import React, { useState } from 'react';
import '../../../assets/styles/ChannelList.css'
import { POST } from '../../../helpers/httphelper';
import { toast as superToast } from 'bulma-toast'
import { useNavigate } from 'react-router-dom'
function AddKey(props) {
    const [token, settoken] = useState('')
    const navigate = useNavigate()
    const checktoken = (e) => {
        e.preventDefault()
        POST('api/token/checktoken', { token }).then(data => {
            if (data.re) {
                if (data.time) {
                    navigate(`/doctorview/${data.tid}/${data.obid}`)
                }
                else {
                    superToast({
                        message: 'Entered Key is Expired',
                        type: 'is-danger',
                        dismissible: true,
                        position: "top-center",
                        animate: { in: 'fadeIn', out: 'fadeOut' },
                    })
                }

            }
            else {
                superToast({
                    message: 'Entered Key is Invalid',
                    type: 'is-danger',
                    dismissible: true,
                    position: "top-center",
                    animate: { in: 'fadeIn', out: 'fadeOut' },
                })
            }



        }).catch(err => {
            console.log(err)
        })
    }
    return (
        <div className='hero  hero_div'>
            <div className='container main_div'>
                <form onSubmit={checktoken}>
                    <div className='columns is-mobile'>
                        <h1 className='title is-1  has-text-centered'>Get Details About Your Patient</h1>
                    </div>
                    <div className='columns is-justify-content-center mt-6 is-mobile'>
                        <div className='column is-8-desktop is-10-tablet is-10-mobile'>
                            <input onChange={(e) => { settoken(e.target.value) }} required type='text' className='input is-large key-input is-rounded' placeholder='Enter the key ' />
                            <h1 className='has-text-centered'>
                                <button className="button is-rounded is-warning mt-5">
                                    <span className="icon">
                                        <i className="fas fa-check-circle"></i>
                                    </span>
                                    <span>Submit</span>
                                </button>
                            </h1>
                        </div>
                    </div >
                </form>
            </div >
        </div >
    );
}

export default AddKey;